"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const dialogues_1 = require("./dialogues");
class MotionSensorError extends react_1.Component {
    constructor(props) {
        super(props);
        this.addDeviceMotionListener = () => {
            window.addEventListener("devicemotion", this.handleDeviceMotionEvent);
            // We don't want to run the following logic until the first,
            // `devicemotion` event, where applicable, has had a chance to fire.
            // `setTimeout` is used here to add the enclosing logic to the event
            // queue and after the first event handler call (if it exists). This
            // is not pretty, but checking for device sensors is non-standardised
            // and non-trivial at the time of writing.
            setTimeout(() => {
                if (!this.state.canAccessOrientationControls) {
                    this.setState({
                        hasAttemptedToAddEventListener: true,
                        showSensorErrorDialogue: true,
                    });
                }
            }, 800);
        };
        this.handleDeviceMotionEvent = (event) => {
            if (!this.state.canAccessOrientationControls) {
                const canAccessOrientationControls = this.state.canAccessOrientationControls ||
                    typeof event.rotationRate?.alpha === "number" ||
                    typeof event.rotationRate?.beta === "number" ||
                    typeof event.rotationRate?.gamma === "number";
                this.setState({
                    canAccessOrientationControls,
                });
            }
        };
        this.dismissIOSDialogue = () => {
            this.setState({
                showIOSDialogue: false,
            });
        };
        this.dismissSensorErrorDialogue = () => {
            this.setState({
                showSensorErrorDialogue: false,
            });
        };
        this.enableOrientationControl = async () => {
            if (this.requstForMotionSensorPermissions !== undefined) {
                const response = await this.requstForMotionSensorPermissions();
                if (response == "granted") {
                    this.addDeviceMotionListener();
                }
            }
            this.dismissIOSDialogue();
        };
        this.readyToShowErrorDialogue = () => {
            return (this.state.hasAttemptedToAddEventListener &&
                !this.state.canAccessOrientationControls);
        };
        this.shouldShowSensorErrorDialogue = () => {
            return (this.isVRMode &&
                !this.state.showIOSDialogue &&
                this.state.showSensorErrorDialogue);
        };
        const DeviceMotionEvent = window["DeviceMotionEvent"];
        const { requestPermission } = DeviceMotionEvent ?? {
            requestPermission: undefined,
        };
        this.isVRMode = !inIrame();
        this.isCypress = !!window?.window?.Cypress;
        this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        this.isLegacyIOS = this.isIOS && requestPermission === undefined;
        this.requstForMotionSensorPermissions = requestPermission;
        this.state = {
            hasAttemptedToAddEventListener: false,
            canAccessOrientationControls: false,
            showIOSDialogue: this.isIOS && this.isVRMode,
            showSensorErrorDialogue: true,
        };
    }
    componentDidMount() {
        this.addDeviceMotionListener();
    }
    componentWillUnmount() {
        window.removeEventListener("devicemotion", this.handleDeviceMotionEvent);
    }
    render() {
        if (!this.isVRMode || this.isCypress) {
            return null;
        }
        if (this.state.showIOSDialogue) {
            if (!this.isLegacyIOS) {
                return (react_1.default.createElement(dialogues_1.IOSEnableOrientationControlsDialogue, { onButtonClick: this.enableOrientationControl }));
            }
            else {
                if (this.readyToShowErrorDialogue()) {
                    return (react_1.default.createElement(dialogues_1.LegacyIOSBlanketEnableOrientationControlsDialogue, { onButtonClick: this.dismissIOSDialogue }));
                }
            }
        }
        if (this.shouldShowSensorErrorDialogue() &&
            this.readyToShowErrorDialogue()) {
            return (react_1.default.createElement(dialogues_1.VRModeNoOrientationControlsDialogue, { onButtonClick: this.dismissSensorErrorDialogue }));
        }
        return null;
    }
}
exports.default = MotionSensorError;
// ===============
// == Functions ==
// ===============
/**
 * This function checks whether or not the current window is inside an iframe.
 * See https://stackoverflow.com/questions/326069.
 * @returns {boolean} A boolean indicating whether or not we are in an `iframe`.
 */
function inIrame() {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
}
